import {Component, ElementRef, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {NavItem} from '../nav-item';
import {Router} from '@angular/router';
import {NavService} from '../nav.service';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListItemComponent implements OnInit, OnDestroy {
  expanded: boolean;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem;
  @Input() depth: number;
  @Input() collapsed: boolean = false;

  popoverVisible: boolean = false;
  popoverTop: number = 0;
  private hideTimeout: any;

  constructor(public navService: NavService,
              public router: Router,
              private el: ElementRef) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        this.expanded = url.indexOf(`${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
      }
    });
  }

  ngOnDestroy() {
    clearTimeout(this.hideTimeout);
  }

  isItemActive(item: NavItem): boolean {
    if (!item.route) {
      return false;
    }
    const currentUrl = this.router.url;
    if (currentUrl === item.route) {
      return true;
    }
    if (item.children) {
      return item.children.some(child => child.route === currentUrl);
    }
    return false;
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
      if (this.navService.appDrawer.mode == 'over') {
        this.navService.closeNav();
      }
    } else {
      this.expanded = !this.expanded;
    }
  }

  showPopover() {
    clearTimeout(this.hideTimeout);
    if (this.collapsed && this.item.children && this.item.children.length) {
      const rect = this.el.nativeElement.getBoundingClientRect();
      this.popoverTop = rect.top;
      this.popoverVisible = true;
    }
  }

  scheduleHidePopover() {
    this.hideTimeout = setTimeout(() => {
      this.popoverVisible = false;
    }, 120);
  }

  keepPopoverOpen() {
    clearTimeout(this.hideTimeout);
  }

  navigateFromPopover(route: string) {
    this.popoverVisible = false;
    this.router.navigate([route]);
  }

  isChildActive(): boolean {
    if (!this.item.children) return false;
    return this.item.children.some(child => child.route === this.router.url);
  }
}
